<template>
  <div>
    <Modal :footer-hide="true" :mask-closable="false" v-model="show" :title="row.orgName" :width="1000" @on-cancel="$emit('cancel')">
      <table class="QHtable" v-if="!$isblank(row)">
        <tr>
          <th style="width: 125px">单位信息</th>
          <th></th>
        </tr>
        <tr>
          <td style="width: 125px"><b>单位名称</b></td>
          <td>
            <span> {{ row.orgName }}</span>
          </td>
        </tr>
        <tr>
          <td style="width: 125px"><b>联系姓名</b></td>
          <td>{{ row.org.contactName }}</td>
        </tr>
        <tr>
          <td style="width: 125px"><b>联系电话</b></td>
          <td>{{ row.org.contactTel }}</td>
        </tr>
        <tr>
          <td style="width: 125px"><b>运输区域</b></td>
          <td>
            <span> {{ row.addressFull }}</span>
          </td>
        </tr>
      
        <tr>
          <td><b>开通时间</b></td>
          <td>{{ $timeFmt(row.created, "YYYY年MM月DD日 HH分mm秒") }} {{ row.from }}</td>
        </tr>
      </table>
    </Modal>
  </div>
</template>
<script>
export default {
  // +----------------------------------------------------------------------
  // | Desc:data
  // +----------------------------------------------------------------------
  data() {
    return {
      Checkbox: true,
      show: false,
      row: {},
    };
  },
  methods: {
    // +----------------------------------------------------------------------
    // | Desc:弹窗详情
    // +----------------------------------------------------------------------
    hiPop(e) {
      //参数整合与接口
      var that = this;
      var https = {
        type: "isRow",
        api: this.$api.getOrgjieshouDetailed,
        parameter: {
          id: e.id,
        },
      };
      this.$httpsApi(https, function (res) {
        that.title = res.data.name;
        that.show = true;
      });
    },
  },
};
</script>
